import { useState, useEffect } from 'react';

function useLocalStorage(key, initialValue) {
    // Initialize the state from localStorage or use the initial value
    const [storedValue, setStoredValue] = useState(() => {
        try {
            const item = window.localStorage.getItem(key);
            if (typeof item != 'string')
                return item ? JSON.parse(item) : initialValue;
            else
                return item ? item : initialValue;
        } catch (error) {
            console.error('Error reading localStorage key:', key, error);
            return initialValue;
        }
    });

    // Update localStorage whenever the state changes
    useEffect(() => {
        try {
            if (typeof storedValue != 'string')
                window.localStorage.setItem(key, JSON.stringify(storedValue));
            else window.localStorage.setItem(key, storedValue);
        } catch (error) {
            console.error('Error setting localStorage key:', key, error);
        }
    }, [key, storedValue]);

    return [storedValue, setStoredValue];
}

export default useLocalStorage;
